import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface ISubtotalFormDialogResult {
    parentGroup: INameId;
    caption: string;
    name?: string;
}
